import React from "react";

const Percent = ({value}) => {
    return <span>{`${value} %`}</span>
};

export default Percent;